
// Module
import { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';

// CSS
import '_Asset/css/User/Page/support.css'

// Component
import { DropDownList, Pagination } from 'User/Component';

// API
import { FaqListApi } from '_Route/Api';


const FAQ = () => {

  // Use module
  const location = useLocation()
  const navigate = useNavigate(); 
  const params = useParams()

  // 검색 및 페이징 API 호출
  const [faqInfo, setFaqInfo] = useState([]); // Search Result Paging Data
  const [faqRes, setFaqRes] = useState([]); // Search Result Data

  const [curPage, setCurPage] = useState(1); // 현재 페이지
  const [pageSize, setPageSize] = useState(30); // 한 페이지에 보여줄 건 수
  const blockSize = 10; // 한 페이지에 보여줄 Pagination 블록 건 수

  const [curIndex, setCurIndex] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // setLoading(false)
    axios.get(FaqListApi, {
      params: {
        faq_title: params.key === undefined ? '' : params.key,
        curPage: curPage,
        pageSize: pageSize,
        blockSize: blockSize
      }
    })
    .then(res => {
      setFaqInfo(res.data.pageInfo);
      setFaqRes(res.data.result);
      setLoading(true)
    })
    .catch(err => {
      console.error(err, "ERROR...")
      setLoading(true)
    })
  }, [location, curPage, pageSize, params.key])


  // Search Input Value Setting
  const [searchVal, setSearchVal] = useState(params.key || '');

  const onChangeSearch = useCallback(e => {
    setSearchVal(e.target.value);
  }, []);
  
  const onKeyPress = (e) => { if(e.key === 'Enter') onSearch(); }
  const onSearch = () => {
    navigate(`/support/frequently-asked-questions${searchVal === '' ? '' : '/' + searchVal}`);
  }

  // Skeleton Component
  const Skeleton = ({num}) => {
    const result = [];

    for (let i = 0; i < num; i++) {
      result.push(
        <li key={i}>
          <button type="button" className="skeleton">
            <i className='icofont-rounded-right'></i>
            <span className="listTit">지원요청에 대한 해결방안은 언제 받을 수 있나요? 검토 중이라고 나옵니다.</span>
            <span className="listDate">2022.07.20</span>
          </button>
        </li>
      )
    }
    return result;
  }


  return (
    <>
      {/* Visual */}
      <div className="visual support">
        <div className="section">
          <div className="visualTitGroup">
            <h2 className="visualTit">Frequently Asked Questions</h2>
            
            <p className="visualTxt">Find the most frequently asked questions and answers in Seyfert Developers.</p>
          </div>
        </div>
      </div>

      <div className="mainContents">
        <div className="section">
          <div className="faqArea areaBox">

            <div className="flexBox between end">
              <div className="fieldGroup">
                <label>노출 게시물 수</label>

                <div className="field">
                  <select name="" className="select md type_1 round_10" onChange={(e) => setPageSize(e.target.value)} defaultValue="30">
                    <option value="10">10개 씩</option>
                    <option value="20">20개 씩</option>
                    <option value="30">30개 씩</option>
                  </select>
                </div>
              </div>

              <fieldset>
                <legend>콘텐츠 검색</legend>

                <div className="fieldGroup mainSearch">
                  <div className="field">
                    <input type="input" className="input md" placeholder="Search Docs" value={searchVal} onChange={onChangeSearch} onKeyPress={onKeyPress}/>
                    <button type="button" className="btn sm sfrtBlue i_only" onClick={onSearch}><i className="icofont-search"></i></button>
                  </div>
                </div>
              </fieldset>
            </div>

            {
              loading ?
                faqRes.length !== 0 ?
                <ul className="dropDownList">
                  {
                    faqRes.map((item, i) => 
                      <DropDownList key={i} item={item} index={i} curIndex={curIndex} setCurIndex={setCurIndex} page='faq' />
                    )
                  }
                  <div className="flexBox between">
                    <p className="pagingTxt">Page {curPage} of {faqInfo.pageCount}. Showing {faqInfo.count} results</p>

                    <Pagination
                      type="type_1"
                      size="sm"
                      curPage={curPage}
                      setCurPage={setCurPage}
                      pageSize={pageSize}
                      blockSize={blockSize}
                      startBlock={faqInfo.startBlock}
                      endBlock={faqInfo.endBlock}
                      pageCount={faqInfo.pageCount}
                    />
                  </div>
                </ul>
                :
                <div className="noDataBox">
                  <i className="icofont-warning-alt"></i>
                  <p>No results found for <span>{params.key}</span>.<br /> Please enter another search term.</p>
                </div>
              :
              <ul className="dropDownList">
                <Skeleton num={15} />
              </ul>
            }
          </div>
        </div>

        {/* <Footer /> */}
      </div>
    </>
  )
}

export default FAQ;